var widget_default = {
  "card": "m8n6W",
  "link": "w5WaO",
  "container": "_7lbzU",
  "image": "hthUL",
  "right": "Fj-bt",
  "cardLayout": "XlsRX",
  "content": "_5nZHm",
  "title": "_24k4T",
  "subtitle": "rVGUF",
  "button": "ZKSxw",
  "button_disabled": "iRQZp",
  "buttonText": "kTO5g",
  "slimLayout": "ULy7C",
  "contentText": "WxT3L"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
